import React, {Fragment, useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom" ;
import PropTypes from "prop-types";
import {PATH_HOME_ROOT, PATH_TEAM_ROOT_LINK, PATH_CHILD_ROOT_LINK} from "root/Wieldy/routePaths";
import { HomePageTabs } from "root/DataFunctions/Constants";
import GlobalContext from "root/contexts/GlobalContext";
import IconTooltip from "root/UI/Tooltip/IconTooltip";
import {getMyChildren} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {ApplicationTypes, doesRoleHaveTab, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";

const WieldySidebarTabs = (props) =>
{
    const globals = useContext(GlobalContext);
    const [ activeTab, setActiveTab ] = useState ( props.activeTab ) ;
    const [data, setData] = useState({isLoading: true, data: [], hasChildren: false});


    const getData = ()  =>{
        getMyChildren(  'active',(response) =>
        {
            const children = getDataFromResponse( response ) ;
            const userHasChildren = children.length > 0 ? true : false;
            setData({isLoading: false, data: children, hasChildren: userHasChildren});
        });
    }

    useEffect(() => {
        getData();
    }, []);

    const isActive = ( myTag ) =>
    {
        return myTag === activeTab ? ' active' : '' ;
    }

    const onMenuItemClicked = ( ev ) =>
    {
        const item = ev.currentTarget.name ;

        setActiveTab( item );

        if ( props.onChangeActiveTab !== undefined )
        {
            props.onChangeActiveTab ( item ) ;
        }
    }

    const homePageMenuLink = ( url, name, icon, popupTitle ) =>
    {
        return (
            <li className="dt-list__item">
                <IconTooltip text={popupTitle}><Link to={url} onClick={onMenuItemClicked} className={ "dt-list__link arc" + isActive(name)} name={name}><i className={"icon " + icon + " icon-xl"}/></Link></IconTooltip>
            </li>
        )
    }

    return (
        <Fragment>
            { data.isLoading === false &&
                <ul className="dt-list dt-list-xl">
                    { doesRoleHaveTab(HomePageTabs.HOME, globals.userType ) && homePageMenuLink(PATH_HOME_ROOT, HomePageTabs.HOME, 'icon-home' , "Home")}
                    { (doesRoleHaveTab(HomePageTabs.TEAM, globals.userType ) || doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, globals.userType)) && homePageMenuLink(PATH_TEAM_ROOT_LINK, HomePageTabs.TEAM, 'icon-team', "Teams" )}
                    { doesRoleHaveTab(HomePageTabs.CHILDREN, globals.userType ) && data.hasChildren && homePageMenuLink(PATH_CHILD_ROOT_LINK, HomePageTabs.CHILDREN, 'icon-user-o', "Children" )}
                </ul>
            }
        </Fragment>
    )
}

export default WieldySidebarTabs;

WieldySidebarTabs.propTypes = {
    onChangeActiveTab: PropTypes.func.isRequired
};